import { Box, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  clinicSection: {
    fontFamily: theme.typography.fontBold,
    textTransform: "uppercase",
    textAlign: "center",
  },
  h1: {
    fontSize: 26,
  },
  h2: {
    marginTop: theme.spacing(1),
    fontSize: 24,
  },
}));

const Header = ({ invoice }) => {
  const {
    patientType: type,
    facility: { name },
  } = invoice;
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      mb={2}
      className={classes.clinicSection}
    >
      <strong className={classes.h1}>{name}</strong>
      <strong className={classes.h2}>
        <FormattedMessage
          id="invoice.laserReceipt.heading"
          defaultMessage={"{type} payment receipt"}
          values={{ type }}
        />
      </strong>
    </Box>
  );
};

Header.propTypes = {
  invoice: PropTypes.shape({
    patientType: PropTypes.string,
    facility: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
};

export default Header;
